import * as yup from "yup";

// Personal Info Schema
const SUPPORTED_FORMATS = ["image/jpeg", "image/png", "image/jpg"];
const FILE_SIZE = 2 * 1024 * 1024; // 2MB
export const personalInfoSchema = yup.object({
  firstName: yup.string().required("First Name is required"),
  lastName: yup.string().required("Last Name is required"),
  dateOfBirth: yup.string().required("Date of Birth is required"),
  mobileNumber: yup
    .string()
    .matches(/^[0-9]{10}$/, "Enter a valid 10-digit mobile number")
    .required("Mobile Number is required"),
  email: yup.string().email("Enter a valid email").required("Email is required"),
  permanentHomeAddress: yup.string().required("Address is required"),
  gender: yup.string().required("Gender is required"),
  city: yup.string().required("City is required"),
  state: yup.string().required("State is required"),
  zipcode: yup
    .string()
    .matches(/^[1-9][0-9]{5}$/, "Enter a valid 6-digit Indian PIN code")
    .required("Zipcode is required"),
  district: yup.string().required("District is required"),
  // profilePhoto: yup.mixed().required("Profile Photo is required"),
  profilePhotoName: yup.mixed().required("Profile Photo is required"),
});

// Completed Education Schema
export const completedEducationItemSchema = yup.object({
  nameSchoolCollege: yup.string().required("School/College Name is required"),
  schoolCollegeAddress: yup.string().required("Address is required"),
  nameOfUniversity: yup.string().required("University Name is required"), 
  course: yup.string().required("Standard is required"),
  stream: yup.string().required("Stream is required"),
  marksObtainedCGPA: yup.string().required("Marks/CGPA is required"),
  yearOfPassing: yup.string().required("Year of Passing is required"),
  principalName: yup.string().required("Principal Name is required"),
  principalContactNumber: yup
    .string()
    .matches(/^[0-9]{10,11}$/, "Enter a valid contact number")
    .required("Principal Contact Number is required"),
  uploadMarksheet: yup.mixed().nullable().required("Marksheet is required"),
});

// Present Education Schema
export const presentEducationSchema = yup.object({
  nameSchoolorCollege: yup.string().required("School/College Name is required"),
  schoolCollegeAddress: yup.string().required("Address is required"),
  nameOfUniversity: yup.string().required("University Name is required"),
  course: yup.string().required("Standard is required"),
  stream: yup.string().required("Stream is required"),
  yearOfAdmission: yup.string().required("Year of Admission is required"),
  currentSemester: yup.string().required("Current Semester is required"),
  courseDuration: yup.string().required("Course Duration is required"),
  principalName: yup.string().required("Principal Name is required"),
  principalContactNumber: yup
    .string()
    .matches(/^[0-9]{10,11}$/, "Enter a valid contact number")
    .required("Principal Contact Number is required"),
  courseFees: yup
    .string()
    .matches(/^\d+(\.\d{1,2})?$/, "Enter a valid course fee amount")
    .required("Course Fees is required"),
  paymentFrequency: yup.string().required("Payment Frequency is required"),
  totalFeesPaid: yup
    .string()
    .matches(/^\d+(\.\d{1,2})?$/, "Enter a valid amount paid")
    .required("Total Fees Paid is required"),
});

// Achievement Items Schema (Array of Objects)
export const achievementItemSchema = yup.array().of(
  yup.object({
    fileName: yup.string().nullable(),
    file: yup.mixed().nullable(),
  })
);

// Family Details Schema
export const familyDetailsSchema = yup.object({
  fathersName: yup.string().required("Father's Name is required"),
  mothersName: yup.string().required("Mother's Name is required"),
  guardiansName: yup.string().required("Father's/Guardian's Name is required"),
  fathersOccupation: yup.string().required("Father's Occupation is required"),
  mothersOccupation: yup.string().required("Mother's Occupation is required"),
  familyIncome: yup
    .number()
    .typeError("Family Income must be a number")
    .min(0, "Income cannot be negative")
    .required("Monthly Family Income is required"),
  contactNumber: yup
    .string()
    .matches(/^[0-9]{10}$/, "Enter a valid 10-digit mobile number")
    .required("Contact Number is required"),
  // siblings: yup.array().of(...)
});

// Scholarship Purpose Schema
export const scholarshipPurposeSchema = yup.object({
  purposeExplanation: yup.string().required("Purpose explanation is required"),
  knowApplication: yup.string().required("How you came to know is required"),
  // otherScholarships: yup.array().of(...)
});

// Uploaded Documents Schema
export const uploadedDocumentItemSchema = yup.object({
  // fileName: yup.string().required("File Name is required"),
  // file: yup.mixed().nullable().required("File is required"),
});

// Bank Details Schema (Array of Bank Accounts)
export const bankDetailsSchema = yup.array().of(
  yup.object({
    bankName: yup.string().required("Bank Name is required"),
    accountHolderName: yup.string().required("Account Holder Name is required"),
    accountNumber: yup.string().required("Account Number is required"),
    ifscCode: yup.string().required("IFSC Code is required"),
    branchName: yup.string().required("Branch Name is required"),
    isPrimary: yup.boolean(),
  })
).test(
  "at-least-one-primary",
  "At least one bank account must be marked as primary",
  (bankDetails) => Array.isArray(bankDetails) && bankDetails.some(b => b.isPrimary === true)
);

// === ✅ Final Overall Schema ===
export const overallValidationSchema = yup.object({
  personalInfo: personalInfoSchema,
  completedEducation: yup
    .array()
    .of(completedEducationItemSchema)
    .min(1, "At least one completed education entry is required"),
  presentEducation: presentEducationSchema,
  achievementsInfo:  achievementItemSchema, // already array
  familyDetails: familyDetailsSchema,
  scholarshipPurpose: scholarshipPurposeSchema,
  uploadedDocuments: yup
    .array()
    .of(uploadedDocumentItemSchema)
    .min(1, "At least one document is required"),
  bankDetails: bankDetailsSchema.min(1, "At least one bank detail is required"),
});
